import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import api from '@home/api'
import * as typesWebpart from '@webparts/store/types'
import { mapGetters } from 'vuex'
import { CalendarEventResponseData } from '@webparts/components/webparts/calendar/types'

export enum GoTo {
    calendar = "calendar",
    workflow = "workflow",
    proccesingWorkflow = "proccesing",
    mail = "mail",
    todo = "todo",
    survey = "survey"
}


@Component({
    computed: mapGetters({
        commonInfoMounted: typesWebpart.WEBPART_COMMONDATA_MOUNTED,
        unreadMails: typesWebpart.WEBPART_UNREADMAIL_DATA,
        todayEvents: typesWebpart.WEBPART_CALENDARTODAYEVENT_DATA
    })
})
export default class MyCountWebpart extends Vue {
    @Prop({ type: Boolean, default: false }) isMailUser!: boolean

    commonInfoMounted!: boolean;
    unreadMails!: ewsResponse.ewsMail[];
    todayEvents!: CalendarEventResponseData[];

    counts: home.homeWebpartCount = {
        todoCount: 0,
        workflowCount: 0,
        proccesingWorkflowCount: 0,
        surveyCount: 0,
        unreadMailCount: 0
    }

    unreadMailCount: number = 0;
    scheduleCount: number = 0;

    @Watch('todayEvents')
    onEventsChanged(newVal: CalendarEventResponseData[]) {
        this.scheduleCount = newVal.length;
    }

    @Watch('unreadMails') 
    onUnreadMailsChanged(newVal: ewsResponse.ewsMail[]) {
        // 백엔드 API에서 데이터를 가져온 후에만 Vuex 데이터를 백업으로 사용
        // 백엔드 API가 0이 아닌 경우에는 Vuex 데이터로 덮어쓰지 않음
        if (this.unreadMailCount === 0 && this.counts.unreadMailCount === 0) {
            this.unreadMailCount = newVal.length;
        }
    }

    created() {      
        this.scheduleCount = this.todayEvents.length;        
        //일정 메일 카운트 현재 불가함
        api.home.getCount().then(result => {
            this.counts = result
            // 백엔드 API에서 읽지 않은 메일 카운트 가져오기
            this.unreadMailCount = result.unreadMailCount || 0;
        }).catch(() => {
            // 백엔드 API 실패 시에만 Vuex 데이터 사용
            this.unreadMailCount = this.unreadMails.length;
        })
    }

    async onClickedIcon(value: GoTo) {

        //메뉴아이디가 다 하드코딩되어있네? 아마 메뉴 아이디가 있어야 좌측 메뉴 보여줄수 있음
        let routePath = ""
        let menuList: appbase.cache.TMenuItem[]
        let menuId: number
        if (value == GoTo.calendar || value == GoTo.mail) {
            // 포탈캐시에서 메뉴아이디 찾음
            // baseUrl이 /Mail 인 메뉴
            menuList = this.portalCache.menu.items.filter((i: appbase.cache.TMenuItem) => i.baseUrl == '/Mail')
            menuId = menuList[0].children.filter((i: appbase.cache.TMenuItem) => i.targetUrl && i.frameUrl?.indexOf(value) > 0)[0].menuId
            // mail MENUID : 6 , calendar MENUID : 7
            // routePath = "/po/home/proxy?MENUID=1105"
            routePath = `/po/home/proxy?MENUID=${menuId}`
        }
        else if (value == GoTo.workflow) {
            // 포탈캐시에서 미결함 Id 찾음
            menuList = this.portalCache.menu.items.filter((i: appbase.cache.TMenuItem) => i.baseUrl == '/Workflow')[0].children
                .filter((ii: appbase.cache.TMenuItem) => ii.targetUrl == '/page/documentlist?dqn=1')[0].children
            menuId = menuList.filter((i: appbase.cache.TMenuItem) => i.targetUrl == `/page/documentlist?dqn=1`)[0].menuId
            routePath = `/workflow/page/documentlist?dqn=1&MENUID=${menuId}&SYSID=1`
        }
        // else if(value== GoTo.proccesingWorkflow){
        //     routePath =  "/workflow/page/documentlist?dqn=1007&MENUID=1082"
        // }
        else if (value == GoTo.todo) {
            routePath = "https://to-do.office.com"
        }

        else if (value == GoTo.survey) {
            const findSurvey = (menu: appbase.cache.TMenuItem[]): appbase.cache.TMenuItem | null => {
                for (var m of menu!) {
                    if (m.targetUrl?.includes('survey')) return m;
                    else if (m.hasChildren) {
                        const sub = findSurvey(m.children)
                        if (sub) return sub
                    }
                }
                return null;
            }
            var id = findSurvey(this.portalCache.menu.items);
            routePath += window.location.origin;

            if (process.env.NODE_ENV === 'production') routePath += '/po'

            if (id) {
                routePath += `/survey/list?type=1&MENUID=${id.menuId}`
            }
            else {
                await (window as any).alertAsync('관리자에게 문의하세요.')
                return
            }

        }

        //this.$router 에서 window.open 으로 변경
        //window.open -> window.location.href 로 변경
        window.location.href = routePath
        // window.open(routePath)
    }
}
